import { createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../../../data/axiosInstance/axiosInstance';
import executor from '../../../data/axiosInstance/executor';

const API_URL = `${process.env.REACT_APP_API_SINISTRI_URL}`;

// Stato iniziale: accesso non ancora letto (caricato false). Finche' il BFF non risponde nessun documento
// e' scaricabile e si apre solo nel VisualizzatoreControllato. Il BFF resta l'enforcer: risponde comunque
// 403 DOCUMENTO_NON_CONSENTITO al download di un documento non scaricabile.
const initialState = {
  ristretto: false,
  categorieScaricabili: null,
  caricato: false,
};

// Se la lettura fallisce non si sa cosa l'utente puo' scaricare: niente e' scaricabile (fail-closed).
export const ACCESSO_FAIL_CLOSED = {
  ristretto: true,
  categorieScaricabili: [],
};

export const DocumentiAccessoSlice = createSlice({
  name: 'documentiAccesso',
  initialState,
  reducers: {
    setDocumentiAccesso: (state, action) => {
      state.ristretto = action.payload?.ristretto === true;
      state.categorieScaricabili = Array.isArray(action.payload?.categorieScaricabili)
        ? action.payload.categorieScaricabili
        : null;
      state.caricato = true;
    },
    azzeraDocumentiAccesso: () => initialState,
  },
});

export const { setDocumentiAccesso, azzeraDocumentiAccesso } = DocumentiAccessoSlice.actions;

// Numero dell'ultima richiesta partita: al cambio task, o quando DetailTask richiama con il sinistro
// appena arrivato, una risposta lenta della richiesta precedente non deve sovrascrivere quella corrente.
let ultimaRichiesta = 0;
// Task dell'ultima richiesta: lo stato torna a "non ancora letto" solo quando il task cambia. Il richiamo
// con il sinistro appena arrivato non lo azzera, cosi' chat, tab e Liquidate non si smontano e rimontano.
let ultimoTaskId;

/**
 * Legge dal BFF quali categorie di documenti l'utente puo' scaricare sul task/sinistro aperto.
 * Risposta: {ristretto:false, categorieScaricabili:null} oppure {ristretto:true, categorieScaricabili:["EMAIL", ...]}.
 * @param {String} taskId task aperto
 * @param {String} sinistroId sinistro del task, se presente
 */
export const fetchDocumentiAccesso = (taskId, sinistroId) => async (dispatch) => {
  const richiesta = ++ultimaRichiesta;
  if (taskId !== ultimoTaskId) {
    // nuovo task: lo stato del task precedente non deve restare appeso
    ultimoTaskId = taskId;
    dispatch(azzeraDocumentiAccesso());
  }
  if (!taskId && !sinistroId) return null;

  const params = new URLSearchParams();
  if (taskId) params.append('taskId', taskId);
  if (sinistroId) params.append('sinistroId', sinistroId);
  const API_URI_CALL = `${API_URL}/api/v1/bff/documenti/accesso?${params.toString()}`;
  const fetchData = async () => axiosInstance.get(API_URI_CALL);

  const [res, err] = await executor.executeAsync(fetchData);
  if (richiesta !== ultimaRichiesta) return null;
  if (err || !res?.data) {
    console.warn('[DocumentiAccesso] lettura accesso documenti fallita: nessun documento scaricabile', err);
    return dispatch(setDocumentiAccesso(ACCESSO_FAIL_CLOSED));
  }
  return dispatch(setDocumentiAccesso(res.data));
};

export default DocumentiAccessoSlice.reducer;
